import { Command } from "./index";
import { Icon } from "@chakra-ui/react";
import { MdCircle } from "react-icons/md";
import { insertSurroundingText } from "../utils/insertSurroundingText";
import { convertGameMakerColourToHex } from "../../../utils/convertGameMakerColourToHex";

export const colourYellow: Command = {
  category: "colour",
  icon: <Icon as={MdCircle} />,
  name: `#${convertGameMakerColourToHex(65535)}`,
  tooltip: "colour as yellow",
  execute: (editorRef) => insertSurroundingText(editorRef, "{{#colourYellow}}", "{{/colourYellow}}"),
};
